export const IPAD_BREAK_POINT = 1024
